import axios from 'axios';
import i18n from '../../i18n';

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'https://api.istanbulviillas.com/api/',
    headers: {
        'Accept': 'application/json',
    },
});

// Request Interceptor: Add Token and Language to Headers
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('admin_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        // Set language header - ensure it's a single language (e.g., 'ar' or 'tr')
        const currentLang = i18n.language?.split('-')[0] || 'ar';
        config.headers['Accept-Language'] = currentLang;

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response Interceptor: Handle Unauthorized Errors
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            // Handle unauthorized (e.g., clear token, redirect to login)
            localStorage.removeItem('admin_token');
            // window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
